import { render, staticRenderFns } from "./GamePendingApproval.vue?vue&type=template&id=90ce1876"
import script from "./GamePendingApproval.vue?vue&type=script&lang=js"
export * from "./GamePendingApproval.vue?vue&type=script&lang=js"
import style0 from "./GamePendingApproval.vue?vue&type=style&index=0&id=90ce1876&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports